/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:29 GMT
 */
const tokens = {
    component: {
        buttonArray: {
            gap: {
                value: "16px",
                type: "dimension",
            },
        },
    },
};
export default tokens;
